import React from "react"
import { Link } from "gatsby"
import { FaDribbble, FaTwitter, FaBehance, FaInstagram, FaAddressCard, FaPhone, FaEnvelope } from "react-icons/fa"

const Footer = () => (
    <footer className="relative z-20 w-full py-8 bg-gradient">
        <div className="container flex flex-col justify-around md:flex-row">
            <div className="flex-1 py-2 mr-6">
                <h1 className="text-4xl font-extrabold">
                    Patric R.
                </h1>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin eu est in enim luctus lobortis. Fusce id odio fermentum purus pulvinar ornare. Praesent laoreet nisi id facilisis congue. Integer in nunc nec mauris lacinia vestibulum in in ligula. </p>
                <p className="pt-2"><a href="https://www.khaledelbalal.me" target="_blank" rel="noopener noreferrer">&copy; 2020 Khaled Elbalal</a></p>
            </div>
            <div className="flex flex-col flex-1 md:flex-row">
                <div className="flex-1 py-2 mr-6">
                    <h4 className="pb-2 text-xl font-bold text-white">Get Around</h4>
                    <ul>
                        <li><Link to="/" className="text-md">Home</Link></li>
                        <li><Link to="/#portfolio" className="text-md">Portfolio</Link></li>
                        <li><Link to="/blog/" className="text-md">Blog</Link></li>
                        <li><Link to="/contact/" className="text-md">Contact</Link></li>
                    </ul>
                </div>
                <div className="flex-1 py-2 mr-6">
                    <h4 className="pb-2 text-xl font-bold text-white">Social</h4>
                    <ul>
                        <li><a href="https://www.instagram.com/khaledelbalal2/" className="text-md" target="_blank" rel="noopener noreferrer"><FaInstagram className="inline" /> Instagram</a></li>
                        <li><a href="https://dribbble.com/khalede" className="text-md" target="_blank" rel="noopener noreferrer"><FaDribbble className="inline" /> Dribbble</a></li>
                        <li><a href="https://www.behance.net/KhaledElbalal" className="text-md" target="_blank" rel="noopener noreferrer"><FaBehance className="inline" /> Behance</a></li>
                        <li><a href="https://twitter.com/KhaledElbalal" className="text-md" target="_blank" rel="noopener noreferrer"><FaTwitter className="inline" /> Twitter</a></li>
                    </ul>
                </div>
                <div className="flex-1 py-2 mr-6">
                    <h4 className="pb-2 text-xl font-bold text-white">Contact</h4>
                    <ul>
                        <li><FaAddressCard className="inline-block" /> 511  Jarvisville Road, Lansing, MI.</li>
                        <li><FaPhone className="inline-block" /> 517-881-0769</li>
                        <li><a href="mailto:me@khaledelbalal.me"><FaEnvelope className="inline-block" /> me@patric.com</a></li>
                    </ul>
                </div>
            </div>

        </div>
    </footer>
)

export default Footer